import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
} from '@mui/material'

interface Props extends SelectProps {
  value: number
  items: { name: string; id: number }[]
  handleSelect: (val: number) => void
  helperText?: string
}
export default function SelectItem({
  items = [],
  handleSelect,
  helperText,
  value,
  ...props
}: Props) {
  const handleChange = (event: SelectChangeEvent<any>) => {
    handleSelect(parseInt(event.target.value))
  }
  return (
    <>
      <FormControl sx={{ minWidth: 120, mt: 2 }} size="small">
        <InputLabel>{props.label}</InputLabel>
        <Select {...props} onChange={handleChange} value={value || ''}>
          <MenuItem value={''}>
            <em>--</em>
          </MenuItem>
          {items.map((v, i) => {
            return (
              <MenuItem value={v.id} key={i}>
                {v.name}
              </MenuItem>
            )
          })}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </>
  )
}
